/** @jsx jsx */
import { Col, Container, Row } from "react-bootstrap";
import { jsx } from "@emotion/react";
import IconInstagram from "@/images/LP-arabe/instagram.svg";
import IcoFacebook from "@/images/LP-arabe/facebook.svg";
import { Link } from "gatsby";
import { footerStyles } from '../assets/styles/Footer.styles';
import logoFooter from '../assets/images/LP-arabe/logo-escola-arabe.svg'

const AboutTwo = () => {
  return (
    <section css={footerStyles}>
      <Container>
        <Row className='row-logo' data-aos="fade-down" data-aos-delay="300">
          <Col md={4} xs={12} className="logo">
            <div className="desktop">
              <Link href="/">
                <img src={logoFooter} title='Educação que prepara para liderar e prosperar' style={{ marginBottom: 20 }} />
              </Link>
              <p>Educação que prepara para liderar e prosperar</p>
            </div>
          </Col>
          <Col md={2} xs={12} className="menu-links">
            <h3>Contato</h3>
            <p>(45) 99910-4312</p>
          </Col>
          <Col md={2} xs={12} className="menu-links">
            <h3>Endereço</h3>
            <p>R. Palestina, 680 - Parque Monjolo, Foz do Iguaçu - PR, 85864-430</p>
          </Col>
          <Col md={2} xs={12} className="menu-links">
            <div className="direction-a">
              <h3>Segmentos</h3>
              <a href="/educacao-infantil">Infantil</a>
              <a href="/ensino-fundamental">Fund Anos Iniciais</a>
            </div>
          </Col>
          <Col md={2} xs={12} className="menu-links">
            <div className="direction-a">
              <h3>Redes sociais</h3>
              <div className='icons'>
                <Link href="https://www.instagram.com/escolaarabebertoni/" target='_blank'>
                  <img src={IconInstagram} alt="icone do instagram" />
                </Link>
                <Link href="https://www.facebook.com/EscolaArabeBertoni/" target='_blank'>
                  <img src={IcoFacebook} alt="icone do facebook" />
                </Link>
              </div>
            </div>
          </Col>
          <Col md={4} xs={12} className="logo mobile" style={{ marginTop: 32 }}>
            <Link href="/">
              <img src={logoFooter} alt='Educação que prepara para liderar e prosperar' style={{ marginBottom: 12 }} />
            </Link>
            <p>Educação que prepara para liderar e prosperar</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutTwo;
